<template>
    <div class="form">
        <ValidationObserver ref="form">
            <div class="row">

                <ValidationProvider
                    class="col-12"
                    name="Stage Name"
                    v-slot="{ errors }"
                    rules="required|min:3"
                >
                    <label class="form-group">
                        <span class="form-label">Name of Act (Stage Name)</span>
                        <input
                            type="text"
                            v-model="form.stage_name"
                            class="form-control"
                        >
                        <FormError :error="errors[0]"  name="Stage Name"></FormError>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="First Name"
                    v-slot="{ errors }"
                    rules="required|min:3|alpha"
                >
                    <label class="form-group">
                        <span class="form-label">First Name*</span>
                        <input
                            type="text"
                            v-model="form.first_name"
                            class="form-control"
                        >
                        <FormError :error="errors[0]"  name="First Name"></FormError>
                    </label>

                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="Last Name"
                    v-slot="{ errors }"
                    rules="required|min:3|alpha"
                >
                    <label class="form-group">
                        <span class="form-label">Last Name*</span>
                        <input type="text" v-model="form.last_name" class="form-control">
                        <FormError :error="errors[0]"  name="Last Name"></FormError>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="Email"
                    v-slot="{ errors }"
                    rules="required|email"
                >
                    <label class="form-group">
                        <span class="form-label">Email Address*</span>
                        <input
                            type="email"
                            v-model="form.email"
                            class="form-control"
                        >
                        <FormError :error="errors[0]"  name="Email"></FormError>
                    </label>

                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="Phone"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <label class="form-group">
                        <span class="form-label">Phone Number*</span>
                        <input
                            type="text"
                            class="form-control"
                            v-mask="'+1 (###) ###-####'"
                            v-model="form.phone"
                        >
                        <FormError :error="errors[0]"  name="Phone"></FormError>
                    </label>

                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="password"
                    v-slot="{ errors }"
                    rules="required|min:8|max:20|password_strength"
                >
                    <label class="form-group">
                        <span class="form-label">Password*</span>
                        <input
                            type="text"
                            v-model="form.password"
                            class="form-control"
                            placeholder="Enter your password"
                        >
                        <FormError :error="errors[0]"  style="color: red; font-size: 10px"  name="password"></FormError>
                    </label>

                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="Password"
                    rules="confirmed:password"
                    v-slot="{ errors }"
                >
                    <label class="form-group">
                        <span class="form-label">Confirm Password*</span>
                        <input
                            type="password"
                            v-model="form.password_confirmation"
                            class="form-control"
                            data-vv-as="password"
                        >
                        <FormError :error="errors[0]" style="color: red; font-size: 10px" name="Password"></FormError>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    class="col-12"
                    name="Terms and Conditions"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-5 mt-2">
                        <label class="form-check">
                            <input type="checkbox" v-model="form.agree" class="form-check-input-checkbox">
                            <span class="form-check-label">Accept <a href="">Terms and Conditions</a> and <a href="">Privacy Policy</a></span>
                            <FormError :error="errors[0]"  name="Terms and Conditions"></FormError>
                        </label>
                    </div>
                </ValidationProvider>

                <div class="col-12">
                    <div class="form-group">
                        <button
                            type="submit"
                            class="btn btn_golden w-100"
                            @click="validateForm"
                        >
                            <span>register</span>
                        </button>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import FormError from "../Common/FormError.vue";
import RegisterAndLoginServices from "../../services/RegisterAndLoginServices";

export default {
    name: "ArtistRegister",
    components: {FormError},
    data() {
        return {
            passwordError: null,
            form: {
                type: 'artist',
                stage_name: null,
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                agree: null,
                password: null,
                code: null,
                password_confirmation: null,
            }
        }
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        this.form.code = code
    },
    methods: {
        async validateForm() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            await this.register()
        },
        async register() {
            try {
                await RegisterAndLoginServices.registerUser(this.form)
                this.$showSuccessMessage()
                window.location.href = '/login'
            } catch (e) {
                this.$showErrorMessage('The user was not registered')
            }
        },
    }

}

</script>



<style scoped>

</style>
